<template>
    <div v-resize="onResize" class="fill-height" ref="container">
        <v-tabs
            ref="tabs"
            active-class="white"
            background-color="grey lighten-3"
            hide-slider
            show-arrows
        >
            <v-tab :to="{ name: 'materialSetting', params: { setting } }">
                Materials
            </v-tab>
            <v-tab :to="{ name: 'extrusionsSetting', params: { setting } }">
                Extrusion Dies
            </v-tab>
        </v-tabs>
        <v-card :loading="loading" flat>
            <v-card-text
                class="overflow-y-auto"
                :style="{ height: `${height}px` }"
            >
                <router-view />
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
    name: 'MaterialSettingTabs',
    props: {
        setting: {
            type: Object,
            default: () => ({}),
        },
    },
    data: () => ({
        height: 0,
        loading: false,
    }),
    mounted() {
        this.onResize()
    },
    methods: {
        ...mapMutations(['setSettingsMenuVisibility']),
        onResize() {
            if (this.$refs.container) {
                this.height =
                    this.$refs.container.clientHeight -
                    (this.$refs.title?.clientHeight || 0) -
                    (this.$refs.subtitle?.clientHeight || 0) -
                    120
            }
        },
    },
}
</script>

<style scoped>
.v-tabs {
    border-bottom: 1px solid #e0e0e0;
}

.v-card {
    border-radius: 0;
}
</style>
